import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import { getCloudinaryImagePathById } from '../../../utilities/images';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import './ReviewResponse.scss';
import ReviewResponseForm from './ReviewResponseForm/ReviewResponseForm';
import { EMPLOYER_ROLES } from '../../../pages/constants';

export default class ReviewResponse extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openClaimForm: false,
            openResponseForm: false,
            employerResponse: this.props.employerResponse,
        };
    }

    static propTypes = {
        employerResponse: PropTypes.shape({
            jobTitle: PropTypes.string,
            comment: PropTypes.string,
            date: PropTypes.string,
        }),
        companyName: PropTypes.string,
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        companyId: PropTypes.number,
        reviewId: PropTypes.number,
    };

    static defaultProps = {
        companyName: '',
        logo: { src: '/icons/company_2x.png', alt: 'default company icon' },
        employerResponse: null,
        userRoles: [],
    };

    toggleReviewResponse = () => {
        this.setState(
            (prevState) => ({ openResponseForm: !prevState.openResponseForm }),
            this.forceUpdate
        );
    };

    handleClaimClick = () => {
        EmitMetric({
            misc_event_type: 'review-employer-page-click',
            misc_event_count: 1,
            company_id: this.props.companyId,
        });
    };

    submitResponse = async (comment, jobTitle) => {
        if (!this.props.companyId || !this.props.reviewId) {
            return;
        }
        try {
            const apiUrl = `/api/company/${this.props.companyId}/job-review/${this.props.reviewId}/response`;
            const result = await axios.post(apiUrl, { jobTitle, comment });
            const currDate = new Date();
            const date = `${currDate.toLocaleDateString('en', {
                year: 'numeric',
                month: 'long',
            })}`;
            if (result) {
                this.setState({
                    employerResponse: { jobTitle, comment, date },
                });
            }
        } catch (e) {
            console.error(e);
            this.setState({ errorMessage: e.inner ? e.inner.pop : e });
        }
        this.toggleReviewResponse();
    };

    renderCompanyLogo = () => {
        const imagePath = getCloudinaryImagePathById(
            this.props.logo.src,
            'small'
        );
        return (
            <img
                src={imagePath}
                className="company-logo"
                alt={`${this.props.companyName} logo`}
            />
        );
    };

    getAttribution = () => {
        const { jobTitle, date } = this.state.employerResponse;
        const company = this.props.companyName;
        return jobTitle
            ? `${jobTitle}, ${date || ''}`
            : `${company} response, ${date || ''}`;
    };

    isUserAuthorized = () => {
        const authorizedRoles = [
            EMPLOYER_ROLES.reviewer,
            EMPLOYER_ROLES.admin,
            'superadmin',
            'customerSuccess',
        ];
        return (
            this.props.userRoles &&
            authorizedRoles.some(
                (role) => this.props.userRoles.indexOf(role) != -1
            )
        );
    };

    renderCTA = () => {
        return this.isUserAuthorized() ? (
            <button
                className="response-cta-text auth button-link"
                onClick={this.toggleReviewResponse}
            >
                <span>Respond to review</span>
            </button>
        ) : (
            <React.Fragment>
                <p className="response-cta-text no-auth">
                    Want to &nbsp;
                    <a
                        onClick={this.handleClaimClick}
                        href={`/employers?id=${this.props.companyId}#claim-your-page`}
                        className="button-link"
                    >
                        submit a response?
                    </a>
                </p>
            </React.Fragment>
        );
    };

    renderReviewResponseForm = () => (
        <ReviewResponseForm
            submitResponse={this.submitResponse}
            toggleReviewResponse={this.toggleReviewResponse}
        />
    );

    render() {
        return !!this.state.employerResponse ? (
            <div className="component-Community-ReviewResponse has-response">
                <h2 className="response-header all-caps-header">
                    Employer response
                </h2>
                <div className="company-header-row">
                    {this.renderCompanyLogo()}
                    <p className="sub-header bold">{this.getAttribution()}</p>
                </div>
                <p className="response-body">
                    {this.state.employerResponse.comment || ''}
                </p>
            </div>
        ) : (
            <div className="component-Community-ReviewResponse response-cta">
                {this.state.openResponseForm
                    ? this.renderReviewResponseForm()
                    : this.renderCTA()}
            </div>
        );
    }
}
